export const projects = [
    {   
      technologies: [],
      id: "6301203d4042e2d798b59dc7",
      title:"SHEYPIZZA", 
      image :"https://sheysathya2.netlify.app/pizzas.svg",
      description:"An ecommerce application developed using react , node redux and mongodb",
      link:"/"
    },
    {   
      technologies: [],
      id: "7301203d4042e2d798b59dc8",
      title:"SHEYSHOP", 
      image :"https://sheysathya2.netlify.app/ecommerce.svg",
      description:"A demo project developed using react , node redux and mongodb",
      link:"/demo1"
    },
    {   
      technologies: [],
      id: "8301203d4042e2d798b59dc9",
      title:"SHEYHOTEL", 
      image :"https://sheysathya2.netlify.app/hotels.svg",
      description:"Another demo project developed using react , node redux and mongodb",
      link:"/demo2"
    },
    {   
      technologies: [],
      id: "9301203d4042e2d798b59dc10",
      title:"SHEYCARS", 
      image :"https://sheysathya2.netlify.app/job.svg",
      description:"Yet another demo project developed using react , node redux and mongodb",
      link:"/demo3"
    },
    {   
      technologies: [],
      id: "10301203d4042e2d798b59dc11",
      title:"SHEYJOBS", 
      image :"https://sheysathya2.netlify.app/social.svg",
      description:"A fourth demo project developed using react , node redux and mongodb",
      link:"/demo4"
    },
    // Add more projects here...
  ]
  